import { Routes } from '@angular/router';

import { coreRoutes } from '@next/core-lib/app';
import { canActivateFeature, FeatureFlags } from '@next/core-lib/featureflag';
import { CustomerGuard } from '@next/core-lib/relationships';

import { BexComponent } from './bex/bex.component';
import { BondaObcDashboardComponent } from './bonda-obc-dashboard/bonda-obc-dashboard.component';
import { ContractComponent } from './contract/contract.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DeliveryComponent } from './delivery/delivery.component';
import { GbmComponent } from './gbm/gbm.component';
import { GreenhouseComponent } from './greenhouse-gas/greenhouse.component';
import { IdentificationComponent } from './identification/identification.component';
import { InboundDeliveryComponent } from './inbound-delivery/inbound-delivery.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { CO2DeliveriesComponent } from './mineral/components/co2-deliveries/co2-deliveries.component';
import { CO2ImpactComponent } from './mineral/components/co2-impact/co2-impact.component';
import { MineralComponent } from './mineral/mineral.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { RegenerativeAgricultureComponent } from './regenerative-agriculture/regenerative-agriculture.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'deliveries',
    component: DeliveryComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'invoice/:invoiceId',
    component: InvoiceComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'invoice',
    component: InvoiceComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'identification',
    component: IdentificationComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'preferences',
    component: PreferencesComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'bex',
    component: BexComponent,
    canActivate: [canActivateFeature],
    data: { featureFlags: FeatureFlags.showMinerals },
  },
  {
    path: 'contract',
    component: ContractComponent,
    canActivate: [canActivateFeature],
    data: { featureFlags: FeatureFlags.showContracts },
  },
  {
    path: 'gbm',
    component: GbmComponent,
    canActivate: [canActivateFeature],
    data: { featureFlags: FeatureFlags.showGBM },
  },
  {
    path: 'greenhouse',
    component: GreenhouseComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'inbound-deliveries',
    component: InboundDeliveryComponent,
    canActivate: [CustomerGuard, canActivateFeature],
    data: { featureFlags: FeatureFlags.showGrain },
  },
  {
    path: 'mineral',
    component: MineralComponent,
    canActivate: [canActivateFeature],
    data: { featureFlags: FeatureFlags.showMinerals },
  },
  {
    path: 'co2-impact-dashboard',
    component: CO2ImpactComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'co2-deliveries-dashboard',
    component: CO2DeliveriesComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'bonda-obc-dashboard',
    component: BondaObcDashboardComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'regenerative-agriculture-dashboard',
    component: RegenerativeAgricultureComponent,
    canActivate: [CustomerGuard],
  },
  ...coreRoutes,
];
